import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import InstallPrompt from "./pwa/InstallPrompt";
import ChavrutaBubble from "./components/chavruta/ChavrutaBubble";
import UpdateAvailableBanner from "./components/UpdateAvailableBanner";
import TextSelectionMenu from "./components/chavruta/TextSelectionMenu";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { BasketProvider } from "./context/BasketContext";
import { LearningProvider } from "./context/LearningContext";
import Landing from "./pages/Landing";
import Library from "./pages/Library";
import Reader from "./pages/Reader";
import SearchPage from "./pages/Search";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import AuthGoogle from "./pages/AuthGoogle";
import Onboarding from "./pages/Onboarding";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Daily from "./pages/Daily";
import Siddur from "./pages/Siddur";
import HebrewCalendar from "./pages/HebrewCalendar";
import MyEvents from "./pages/MyEvents";
import BeitMidrash from "./pages/BeitMidrash";
import Notebook from "./pages/Notebook";
import HighlightsPage from "./pages/Highlights";
import MyLessons from "./pages/MyLessons";
import Donate from "./pages/Donate";
import DonateThankYou from "./pages/DonateThankYou";
import AdminDashboard from "./pages/AdminDashboard";
import AdminAggadot from "./pages/AdminAggadot";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import GematriaPreview from "./pages/_GematriaPreview";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ReferralCapture from "./components/ReferralCapture";
import ScrollLockReleaseGuard from "./components/ScrollLockReleaseGuard";
import GlobalAuthGate from "./components/GlobalAuthGate";
import WeeklyCheckin from "./components/WeeklyCheckin";
import { BasketFloatingButton } from "./components/BasketSheet";
import TutorialOverlay from "./components/TutorialOverlay";
import LocationPermissionPrompt from "./components/LocationPermissionPrompt";
import { TutorialProvider } from "./context/TutorialContext";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
        <LearningProvider>
          <BasketProvider>
            <TutorialProvider>
            <BrowserRouter>
            <ScrollLockReleaseGuard />
            <ReferralCapture />
            <GlobalAuthGate />
            <WeeklyCheckin />
            <div className="min-h-screen flex flex-col">
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/library" element={<Library />} />
                  <Route path="/daily" element={<Daily />} />
                  <Route path="/siddur" element={<Siddur />} />
                  <Route path="/calendar" element={<HebrewCalendar />} />
                  <Route path="/calendar/my-events" element={<MyEvents />} />
                  <Route path="/beit-midrash" element={<BeitMidrash />} />
                  <Route path="/notebook" element={<Notebook />} />
                  <Route path="/beit-midrash/highlights" element={<HighlightsPage />} />
                  <Route path="/beit-midrash/lessons" element={<MyLessons />} />
                  <Route path="/reader/:bookSlug/:chapter" element={<Reader />} />
                  <Route path="/reader/:bookSlug" element={<Reader />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/auth/callback" element={<AuthCallback />} />
                  <Route path="/auth/google" element={<AuthGoogle />} />
                  <Route path="/onboarding" element={<Onboarding />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/donate" element={<Donate />} />
                  <Route path="/donate/thank-you" element={<DonateThankYou />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/aggadot" element={<AdminAggadot />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/__gematria-preview" element={<GematriaPreview />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <BasketFloatingButton />
            <ChavrutaBubble />
            <UpdateAvailableBanner />
            <TextSelectionMenu />
            <InstallPrompt />
            <TutorialOverlay />
            <LocationPermissionPrompt />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
          </TutorialProvider>
        </BasketProvider>
        </LearningProvider>
      </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
